/**
 * Simple image optimization utilities
 */

// Check if browser supports WebP
export const supportsWebP = () => {
  const canvas = document.createElement('canvas');
  return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
};

// Get optimized image URL (WebP if supported, fallback to original)
export const getOptimizedImageUrl = (originalUrl) => {
  if (!originalUrl) return null;
  
  if (supportsWebP()) {
    // Try to get WebP version if available
    const webpUrl = originalUrl.replace(/\.(jpg|jpeg|png)$/i, '.webp');
    return webpUrl;
  }
  
  return originalUrl;
};

// Simple image compression for uploads
export const compressImage = (file, quality = 0.8, maxWidth = 1200) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      // Calculate new dimensions
      let { width, height } = img;
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }
      
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/jpeg', quality);
    };
    
    img.src = URL.createObjectURL(file);
  });
};

// Get responsive image URL based on screen size
export const getResponsiveImageUrl = (originalUrl, screenWidth) => {
  if (!originalUrl) return null;
  
  // Simple responsive logic
  if (screenWidth < 768) {
    // Mobile - try to get smaller version
    return originalUrl.replace(/\.(jpg|jpeg|png|webp)$/i, '_small.$1');
  } else if (screenWidth < 1200) {
    // Tablet - try medium version
    return originalUrl.replace(/\.(jpg|jpeg|png|webp)$/i, '_medium.$1');
  }
  
  // Desktop - use original
  return originalUrl;
};
